var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"alt":"signature","src":require(("@/assets/" + (_vm.signature.image))),"height":_vm.signature.heightPDF,"aspect-ratio":"1"}})}
var staticRenderFns = []

export { render, staticRenderFns }